<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <h1>Plugin Settings</h1>
    <div class="d-flex flex-row flex-wrap row-gap-3 mt-4">
      <div v-for="(plugin, index) in system_settings" :key="index"
           class="col-lg-4 col-md-6 col-sm-6">
        <div class="border bg-white d-flex flex-row" style="align-items: center; border-radius: 10px">
          <div class="bg-success text-white font-weight-bold fs-4 py-4 px-2 flex-grow-1 text-center">{{
              plugin.system_key.split('_').map(word => word.charAt(0).toUpperCase() +
                  word.slice(1).toLowerCase()).join(' ')
            }}
          </div>
          <div class="form-check form-switch text-end me-2" style="width: 42px">
            <input :id="plugin.system_key" v-model="plugin.toggleValue" class="form-check-input"
                   role="switch"
                   style="transform: scale(1.8);" type="checkbox" @change="savePluginSettings(plugin)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SystemSettingsService from "@/services/system-settings.service";

export default {
  name: "PluginSettings",
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Plugins',
          href: '#',
        },
      ],
      system_settings: [],
    };
  },
  methods: {
    async getPluginSettings() {
      try {
        const response = await SystemSettingsService.getPlugins();
        if (response.data) {
          const show_cms_search_bar_obj = response.data.find(item => item.system_key === "show_cms_search_bar");
          const show_cms_search_bar = show_cms_search_bar_obj ? show_cms_search_bar_obj.value : null;
          localStorage.setItem('show_cms_search_bar', show_cms_search_bar);

          this.system_settings = response.data.map(setting => ({
            ...setting,
            originalValue: setting.value,
            isChanged: false,
            toggleValue: setting.value == 'Y' ? true : false,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    },
    async savePluginSettings(system_setting) {
      try {
        if (system_setting.toggleValue == true) {
          system_setting.value = 'Y';
        } else {
          system_setting.value = 'N';
        }
        if (system_setting.system_key == 'show_cms_search_bar') {
          localStorage.setItem('show_cms_search_bar', system_setting.value);
          window.dispatchEvent(new CustomEvent('show_cms_search_bar_storage_changed', {
            detail: {
              storage: localStorage.getItem('show_cms_search_bar')
            }
          }));
        }
        const response = await SystemSettingsService.saveSystemSettings(system_setting);
        if (response.data) {
          if (response.data.messageCode === 1) {
            this.showNotification('success', response.data.message);
            system_setting.originalValue = system_setting.value;
            system_setting.isChanged = false;
          } else {
            this.showNotification('error', response.data.message);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Plugin Settings',
        text: message,
      });
    },
  },
  mounted() {
    this.getPluginSettings();
  },
};
</script>

<style scoped>
</style>